import { render, staticRenderFns } from "./NewUserEcommerce.vue?vue&type=template&id=180b7a2e"
import script from "./NewUserEcommerce.vue?vue&type=script&lang=js"
export * from "./NewUserEcommerce.vue?vue&type=script&lang=js"
import style0 from "./NewUserEcommerce.vue?vue&type=style&index=0&id=180b7a2e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports